import { Button as AntButton, Dropdown, MenuProps, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';

import { ReactComponent as Ellipsis } from '../../../assets/ellipsis.svg';

interface RequiredDocumentTableProps {
  data: RequiredDocument[];
  onEdit: (record: RequiredDocument) => void;
}

const RequiredDocumentTable = ({ data, onEdit }: RequiredDocumentTableProps) => {
  const columns: ColumnsType<RequiredDocument> = [
    {
      key: 'name',
      title: 'Document Name',
      dataIndex: 'name',
    },
    {
      key: 'programTypeName',
      title: 'Program Type',
      dataIndex: 'programTypeName',
      render: (_, record) => record?.programType || `Program Type #${record?.programTypeId}`,
    },
    {
      key: 'allowedFileTypes',
      title: 'Allowed Types',
      dataIndex: 'allowedFileTypes',
    },
    {
      key: 'maxFileSizeInMB',
      title: 'Max Size',
      dataIndex: 'maxFileSizeInMB',
      render: (_, record) => `${record?.maxFileSizeInMB} MB`,
    },
    {
      key: 'isRequired',
      title: 'Required',
      dataIndex: 'isRequired',
      render: (_, record) => (record?.isRequired ? 'Yes' : 'No'),
    },
    {
      key: 'description',
      title: 'Description',
      dataIndex: 'description',
      render: (_, record) => record?.description || '-',
    },
    {
      key: 'action',
      title: '',
      render: (_, record) => {
        const items: MenuProps['items'] = [
          {
            key: 'edit',
            label: 'Edit',
            onClick: () => onEdit(record),
          },
        ];

        return (
          <Dropdown menu={{ items }} trigger={['click']}>
            <AntButton type="text" icon={<Ellipsis />} />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <Table
      dataSource={data?.map((item) => ({ ...item, key: item.id }))}
      columns={columns}
      pagination={{ position: ['bottomCenter'] }}
      rowKey={(record) => record.id}
    />
  );
};

export default RequiredDocumentTable;
